export default {
  map_areas: {
    'france.chambord.chateau': {
      'enceintebasse.0.accueil': 'Empfang/Kartenverkauf',
      'courchateau.0.sud': 'Schlosshof',
      'donjon.0.vestibulesud': 'Südlicher Kreuzarm',
      'donjon.0.salledeschasses': 'Jagdsaal',
      'donjon.0.vestibuleest': 'Östlicher Kreuzarm',
      'donjon.0.salledesillustres': 'Saal der Berühmtheiten',
      'donjon.0.vestibulenord': 'Nördlicher Kreuzarm',
      'donjon.0.salledesbourbons': 'Bourbonen-Saal',
      'donjon.0.vestibuleouest': 'Westlicher Kreuzarm',
      'donojon.0.salleaudiovisuelle': 'Medienraum',
      'enceintebasse.0.cafeorleans': "Café d'Orléans",
      'enceintebasse.0.salledescarrosses': 'Kutschensammlung',
      'enceintebasse.0.fosselatrine': 'Latrinengruben',
      'enceintebasse.0.depotlapidaire': 'Lapidarium',
      'enceintebass.0.toilettes': 'Toiletten',
      'donjon.0.cuisinepolignac': 'Küchen aus dem 18. Jahrhundert',
      'enceintebasse.0.avantboutique': 'Shop - Ausgang',
      'enceintebasse.0.boutique': 'Shop - Ausgang',
      'enceintebasse.0.sortie': 'Shop - Ausgang',
      'courchateau.0.ouest': 'Schlosshof',
      'donjon.0.cabinetchasses': 'Jagdkabinett',
      'donjon.1.escaliers': 'Ausgang Stiege 1. Stock',
      'donjon.1.cafemarechaldesaxe': 'Westlicher Saal',
      'donjon.1.chambredeslauriers': 'Oleanderzimmer ',
      'donjon.1.cabinetdetravailsudouest': 'Arbeitskabinett ',
      'donjon.1.chambredeconti': 'Schlafzimmer für Gäste',
      'donjon.1.theatredemoliere': 'Ehemaliges Theater Molières',
      'donjon.1.chambrecharlesquint': 'Museum des Grafen von Chambord - 1',
      'donjon.1.museecomtedechambord2': 'Museum des Grafen von Chambord - 2',
      'donjon.1.museecomtedechambord3': 'Museum des Grafen von Chambord - 3',
      'donjon.1.museecomtedechambord4': 'Museum des Grafen von Chambord - 4',
      'donjon.1.museecomtedechambord5': 'Museum des Grafen von Chambord - 5',
      'donjon.1.loggiaest': 'Nördliche Loggia - erste Etage',
      'donjon.1.salleest': 'Östlicher Saal',
      'donjon.1.chambredeparade': 'Paradezimmer',
      'donjon.1.salondecompagnie': 'Gesellschaftszimmer ',
      'donjon.1.premiereantichambre': 'Erstes Vorzimmer ',
      'donjon.1.loggiaouest': 'Westliche Loggia',
      'donjon.1.chambredelareine': 'Zimmer der Königin ',
      'donjon.1.antichambredelareine': 'Vorzimmer der Königin',
      'aileroyale.1.galerieroyale': 'Galerie im königlichen Flügel',
      'aileroyale.1.oratoire': 'Gebetsraum von Franz I.',
      'aileroyale.1.garderobe': 'Ankleidezimmer von Franz I.',
      'aileroyale.1.chambreduroi': 'Zimmer von Franz I. ',
      'aileroyale.1.cabinetdetravailduroi': 'Arbeitskabinett von Franz I. ',
      'aileroyale.1.salleduconseil': 'Königssaal ',
      'aileroyale.1.galeriemarignan': 'Galerie Marignan',
      'ailechapelle.1.galeriechapelle': 'Kapellengalerie',
      'ailechapelle.1.chapelle': 'Kapelle',
      'donjon.1.antichambreconti': 'Vorzimmer ',
      'donjon.1.chambredumarechaldesaxe': 'Privates Schlafzimmer',
      'donjon.1.cabinetdesserte': 'Kabinett ',
      'donjon.1.cabinetgouverneur': 'Kabinett',
      'donjon.1.chambredugouverneur': 'Zimmer des Gouverneurs ',
      'donjon.1.museecomtedechambord6': 'Museum des Grafen von Chambord - 6',
      'donjon.2.theatredesaxe': 'Ehemaliges Theater des Marschalls von Sachsen ',
      'donjon.2.sallevouteeouest': 'Gewölbesaal - Westen',
      'donjon.2.sallevouteeest': 'Gewölbesaal - Osten',
      'donjon.2.sallevouteesud': 'Gewölbesaal - Süden',
      'donjon.2.salledexposition6': 'Ausstellungssaal - 6',
      'donjon.2.salledexposition7': 'Ausstellungssaal - 7',
      'donjon.2.salledexposition8': 'Ausstellungssaal - 8',
      'donjon.2.salledexposition9': 'Ausstellungssaal - 9',
      'donjon.2.salledexposition10': 'Ausstellungssaal - 10',
      'donjon.2.loggiaest': 'Östliche Loggia - zweite Etage',
      'donjon.2.salledexposition1': 'Ausstellungssaal - 1',
      'donjon.2.salledexposition2': 'Ausstellungssaal - 2',
      'donjon.2.salledexposition3': 'Ausstellungssaal - 3',
      'donjon.2.salledexposition4': 'Ausstellungssaal - 4',
      'donjon.2.salledexposition5': 'Ausstellungssaal - 5',
      'ailechapelle.2.galeriedestrophees': 'Trophäengalerie',
      'donjon.3.escaliernord': 'Ausgang Nördliche Treppe',
      'donjon.3.escaliersud': 'Ausgang Südliche Treppe',
      'donjon.3.terrassesud': 'Südliche Terrasse',
      'donjon.3.terrasseest': 'Östliche Terrasse',
      'donjon.3.terrassenord': 'Nördliche Terrasse',
      'donjon.3.terrasseouest': 'Westliche Terrasse',
    },
    'france.paris.conciergerie': {
      'accueil.0': 'Empfang und Kartenverkauf',
      'sallegensdarmesest.0': 'Salle des Gens d’Armes (Saal der Bewaffneten)',
      'cuisines.0': 'Die Küchen',
      'sallegensdarmesouest.0': 'Salle des Gens d’Armes (Saal der Bewaffneten)',
      'salledesgardes.0': 'Salle des Gardes (Saal der Wachen)',
      'cellulemarieantoinette.0': 'Zelle der Königin Marie Antoinette',
      'couloirdesprisonniers.0': 'Korridor der Gefangenen',
      'chapelledesgirondins.0': 'Kapelle ',
      'courdesfemmes.0': 'Frauenhof',
      'salleexposition.0': 'Die Französische Revolution',
      'salledescondamnes.1': 'Salle des Noms',
      'couloirdesprisonniersentresol.1': 'Korridor der Gefangenen - Erste Etage',
      'museeprison.1': 'Französische Revolution und Justiz',
    },
    'france.avignon.palais-des-papes': {
      'grandetresoreriehaute.-1': 'Große obere Schatzkammer',
      'grandetresoreriebasse.-1': 'Große untere Schatzkammer',
      'tresorbas.-1': 'Untere Schatzkammer',
      'jardins.-1': 'Gärten',
      'accueil.0': 'Empfang',
      'courhonneurouest.0': 'Ehrenhof ',
      'courhonneurest.0': 'Ehrenhof ',
      'courhonneurramp.0': 'Ehrenhof ',
      'courcloitre.0': 'Hof des Alten Palasts ',
      'consistoire.0': 'Konsistorium',
      'sallejesus.0': 'Jesus-Saal',
      'revestiaire.0': 'Päpstliche Sakristei',
      'chambrecamerier.0': 'Antike Zimmer des Kämmerers',
      'escalierhonneurground.0': 'Ehrentreppe',
      'grandeaudienceest.0': 'Große Audienz - Osten',
      'grandeaudienceouest.0': 'Große Audienz - West',
      'livredor.0': 'Empfang',
      'courpalaisvieux.1': 'Osten obere Galerie',
      'grandtinelnord.1': 'Grand Tinel - Norden',
      'grandtinelsud.1': 'Grand Tinel - Süden',
      'cuisinehaute.1': 'Obere Küche',
      'chambreparement.1': 'Paramentenkammer ',
      'chambrepape.1': 'Papstzimmer',
      'chambrecerf.1': 'Hirschzimmer ',
      'sacristienord.1': 'Nordsakristei',
      'grandechapelleest.1': 'Große Kapelle',
      'revestiairecardinaux.1': 'Garderobe der Kardinäle',
      'grandechapelleouest.1': 'Große Kapelle',
      'chambreneuvecamerier.1': 'Neues Zimmer des Kämmerers ',
      'escaliertourgache.1': 'Tour de la Gâche ',
      'chambrenotaires.1': 'Saal der Notare ',
      'loggia.1': 'Loggia - Ablassfenster ',
      'escalierhonneur1stf.1': 'Ehrentreppe',
      'coursivegrandsdignitaires.2': 'Galerie der Grands Dignitaires ',
      'cafegrandsdignitaires.2': 'Café der Grands Dignitaires ',
      'terrassegrandsdignitaires.2': 'Terrasse der Grands Dignitaires',
      'toilettesgrandeaudience.0': 'Toiletten Große Audienz',
      'salleartillerie.0': 'Alarme',
    },
    'france.sainte-mere-eglise.airborne-museum': {
      'accueil.0.caisse': 'Empfang, Ticketverkauf, Boutique',
      'parc.0.sherman': 'Park',
      'waco.0.droite': 'Waco-Gebäude, der Lastensegler',
      'waco.0.gauche': 'Waco-Gebäude, der Steg',
      'parc.0.truck': 'Park',
      'c47.0': 'C-47-Gebäude',
      'c47.0.gauche': 'C-47-Gebäude - Eingang',
      'c47.0.videoroom': 'C-47-Gebäude, Videoraum',
      'c47.briefingroom': 'Briefing Room, England',
      'c47.0.droite': 'C-47-Gebäude - Ausgang',
      'accueil.0.sortie': 'Empfang, Ticketverkauf, Boutique',
      'parc.0.entreeneptune': 'Park',
      'reagan.0': 'Reagan-Gebäude',
      'neptune.0.sortie': 'Steg nach Reagan-Gebäude',
      'neptune.0.para': 'Operation Neptune-Gebaüde, Eingang',
      'neptune.0.sasstemere': 'Sainte-Mère-Eglise: der Angriff',
      'neptune.0.sme': 'Sainte-Mère-Eglise: D-Day',
      'neptune.0.merderet': 'Der Kampf um La Fière (2. Teil)',
      'neptune.0.haies': 'Der Heckenkrieg',
      'neptune.0.ambulance': 'Operation Neptune-Gebaüde',
      'neptune.0.livredor': 'Operation Neptune-Gebaüde',
      'accueil.0.demotimegate': 'Sainte-Mère-Église unter deutscher Besatzung',
      'neptune.0.ambulancetimegate': 'Operation Neptune-Gebaüde',
      'c47.1.passerelle': 'C-47-Gebäude, Steg',
      'c47.1.top': 'C-47-Gebäude, das Belvedere',
    },
    'france.blois.chateau': {
      'accueil.0': 'Eingangsbereich',
      'cour.0.livredor': 'Innenhof',
      'cour.0.est': 'Innenhof',
      'cour.0.nord': 'Innenhof',
      'chapelle.0': 'Kapelle Saint-Calais',
      'cour.0.sud': 'Innenhof',
      'cour.0.ouest': 'Innenhof',
      'etatsgeneraux.0': 'Ständesaal',
      'guichet.0': 'Ticketverkauf',
      'terrassefoix.0': 'Terrasse des Foix-Turms',
      'escaliersarchitecture.0': 'Treppe zu den Architektursälen',
      'interpretation1.0': 'Schlossgeschichte Saal 1',
      'interpretation2.0': 'Schlossgeschichte Saal 2',
      'interpretation3.0': 'Schlossgeschichte Saal 3',
      'architecture1.0': 'Architektursaal Nr. 1',
      'architecture2.0': 'Architektursaal Nr. 2',
      'architecture3.0': 'Architektursaal Nr. 3',
      'architecture4.0': 'Architektursaal Nr. 4',
      'tourdumilieu.0': 'Mittelturm',
      'jardins.0': 'Bastion der Maria von Medici',
      'escalierhonneur.0': 'Ehrentreppe Gastons d‘Orléans',
      'salleroi.1': 'Königssaal',
      'sallevalois.1': 'Valois-Saal',
      'galeriereine.1': 'Galerie der Königin',
      'garderobe.1': 'Garderobe',
      'chambrereine.1': 'Schlafzimmer der Königin',
      'oratoire.1': 'Oratorium',
      'studiolo.1': 'Studiolo',
      'galerietapisserie.1': 'Tapisserien-Galerie',
      'salleviergeenfant.1': 'Saal der Jungfrauen mit Kind',
      'sallechateaux.1': 'Saal der Schlösser',
      'sallehistoires.1': 'Geschichten-Saal',
      'sallepetitsformats.1': 'Saal der kleinen Formate',
      'salleportraits.1': 'Porträt-Saal',
      'sallesalons.1': 'Saal der Salons',
      'salleblois.1': 'Blois-Saal',
      'galeriepaysage.1': 'Landschaftsgalerie',
      'gastonexpo1.1': 'Saal für Wechselausstellungen',
      'gastonexpo2.1': 'Saal für Wechselausstellungen',
      'gastonexpo3.1': 'Saal für Wechselausstellungen',
      'cabinetetiquette.2': 'Kabinett der Etikette',
      'cabinetguerrereligions.2': 'Kabinett der Religionskriege',
      'cabinetneuf.2': 'Neues Kabinett',
      'chambreroi.2': 'Schlafzimmer des Königs',
      'galeriebelvedere.2': 'Belvedere der Gartenanlagen',
      'galerieduban.2': 'Duban-Galerie',
      'salleconseil.2': 'Ratssaal',
      'salleneorenaissance.2': 'Neorenaissance-Saal',
    },
    'france.la-mongie.pic-du-midi': {
      'restaurant.-1': 'Restaurant',
      'accueil.0': 'Empfang',
      'galeriepanorama.0': 'Panorama-Galerie',
      'couloirnord.0': 'Terrasse des Pic du Midi',
      'bistrot.0': 'Bistrot',
      'maquette.0': 'Modellsaal',
      'terrasse.0': 'Terrasse des Pic du Midi',
      'galeriepanorama.terrasse.0': 'Die Terrasse im Jahr 1906',
      'galeriepanorama.coupolebois.0': 'Die Holzpavillons',
      'galeriepanorama.panorama.0': 'Panorama-Galerie',
      'maquette.bibliotheque.0': 'Die Bibliothek Im Jahr 1930',
      'galeriepanorama.galerie.0': 'Die Galerie im Jahr 1907',
      'terrasse.coupolebaillaud.0': 'Die Baillaud-Kuppel im Jahr 1937',
      'terrasse.terrasse.0': 'Die Terrasse im Jahr 1906',
      'terrasse.panorama.0': 'Terrasse des Pic du Midi',
      'terrasse.coupoles.0': 'Die Kuppeln',
      'maquette.chambre.0': 'Das Schlafzimmer im Jahr 1909',
      'experiences.1': 'Experimentierbereich',
      'cieletoile.1': 'Lager Sternenhimmel',
      'merveilles.2': 'Galerie der Wunder',
      'planetarium.2': 'Planetarium',
      'merveilles.coupoles.2': 'Die Kuppeln',
      'merveilles.cuisine.2': 'Die Küche im Jahr 1907',
      'merveilles.coupolebaillaud.2': 'Die Baillaud-Kuppel im Jahr 1937',
    },
    'france.loches.donjon': {
      'carriere.-4': 'Steinbruch',
      'cachoteveques.-3': 'Kerker der Bischöfe',
      'cachotsforza.-2': 'Kerker Ludovico Sforzas',
      'sallesforza.-1': 'Sforzesca-Saal',
      'cachotbalue.-1': 'Kardinal Balues Verlies',
      'accueil.0': 'Empfangsbereich',
      'palier.0': 'Treppenabsatz',
      'tourneuve.0': 'Raum Ein Ort eine Geschichte',
      'courdonjon.0': 'Hof des Wehrturms',
      'courchateauwest.0': 'Schlosshof',
      'jardinmedieval.0': 'Mittelalterlicher Garten',
      'tourabec.0': 'Turm',
      'courchateaueast.0': 'Schlosshof',
      'cellier.0': 'Vorratskeller',
      'donjon.0': 'Dungeontreppe',
      'tourporte.0': 'Torturm',
      'sallegardes.1': 'Saal der Wachen',
      'excentriques.1': 'Kerker der Exzentriker',
      'tourporte.1': 'Torturm',
      'grandesalle.1': 'Großer Saal',
      'chapelle.2': 'Kapelle',
      'chambrecomptale.2': 'Gemach des Grafen',
      'celluleduc.2': 'Zelle des Herzogs von Alençon',
      'rebelles.2': 'Wohnräume des Kerkermeisters',
      'niveaudefensif.3': 'Verteidigungsebene',
      'terrasse.3': 'Terrasse',
    },
    'france.amboise.chateau': {
      'accueil.-1': 'Empfang und Kartenverkauf',
      'orangerie.-1': 'Orangerie: Kaffeehaus und Toiletten',
      'rampeorangerie.-1': 'Auffahrtsrampe zum Schloss',
      'courheurtault.-1': 'Hof des Heurtault-Turms',
      'rampe.-1': 'Auffahrtsrampe zum Schloss',
      'tourheurtault.-1': 'Heurtault-Turm',
      'chapelle.0': 'Hubertuskapelle',
      'sallegardes.0': 'Saal der Wachen',
      'promenoir.0': 'Wachengang',
      'pilier.0': 'Säulenhalle',
      'terrassesnord.0': 'Terrassen',
      'terrassessud.0': 'Terrassen',
      'tambourineurs.1': 'Saal der Trommler',
      'grandesalle.1': 'Großer Saal',
      'grandechambre.1': 'Großes Zimmer',
      'chambreroi.1': 'Zimmer des Königs',
      'garderobe.1': 'Ankleidezimmer',
      'naplesouest.1': 'Gärten von Neapel',
      'terrassesup.1': 'Obere Terrasse',
      'alleesnordouest.1': 'Büste von Leonardo da Vinci',
      'alleessudouest.1': 'Garten: Die Alleen',
      'alleesnordest.1': 'Garten: Die Alleen',
      'alleessudest.1': 'Garten: Die Alleen',
      'aumale.1': 'Aumale-Galerie',
      'minimes.1': 'Reiterrampe',
      'jardinorient.1': 'Orientgarten',
      'naplesest.1': 'Gärten von Neapel',
      'jardinmidi.1': 'Südlicher Garten',
      'portelions.1': 'Löwentor',
      'new.area': 'Büste von Leonardo da Vinci',
      'cabinetorleans.2': 'Kabinett Orléans-Penthièvre',
      'chambreorleans.2': 'Orléans-Zimmer',
      'salonmusique.2': 'Musiksalon',
      'minimes.2': 'Dach des Minimes-Turms',
    },
    'france.chinon.forteresse': {
      'argenton.-3': 'Argenton-Turm, Eb. -3',
      'argenton.-2': 'Argenton-Turm, Eb. -2',
      'chiens.-2': 'Hundeturm, Eb. -2',
      'chiens.-1': 'Hundeturm, Eb. -1',
      'argenton.-1': 'Argenton-Turm, Eb. -1',
      'coudray.-1': 'Coudray-Turm, Eb. -1',
      'boissy.-1': 'Boissy-Turm, Eb. -1',
      'accueil.0': 'Empfang, Ticketverkauf, Boutique',
      'chiens.0': 'Hundeturm, Eb. 0',
      'horloge.0': 'Uhrturm, Eb. 0',
      'forteresse.0.aula': 'Plantagenet-Saal',
      'forteresse.0.archeo': 'Geschichts- und Archäologiesaal',
      'forteresse.0.dependances': 'Küchen, Raum 2',
      'forteresse.0.cuisine': 'Küchen, Raum 1',
      'boissy.0': 'Boissy-Turm, Eb. 0',
      'moulin.0': 'Mühlenturm, Eb. 0',
      'coudray.0': 'Coudray-Turm, Eb. 0',
      'fortdumilieu.0.bombarde': 'Park der Festung',
      'fortdumilieu.0.sallereco': 'Park der Festung',
      'acceschateau.0': 'Zugang zum Schloss',
      'rampeacces.0': 'Zugang zum Schloss',
      'fortdumilieu.0.chapellesud': 'Park der Festung',
      'fortdumilieu.0.chapellenord': 'Park der Festung',
      'fortdumilieu.0.cafe': 'Teesalon mit leckeren Spezialitäten',
      'argenton.0': 'Argenton-Turm, Terrasse',
      'fortducoudray.0.courtourcoudray': 'Hof von Fort Coudray',
      'fortducoudray.0': 'Hof von Fort Coudray',
      'horloge.+1': 'Uhrturm, Eb. 1',
      'chiens.+1': 'Hundeturm, Terrasse',
      'forteresse.+1.marieanjou': 'Saal mit Jeanne d‘Arc-Druckplatten',
      'forteresse.+1.jeannedarc': 'Saal mit Jeanne d‘Arc-Kollektionen',
      'forteresse.+1.parement': 'Prunkschlafzimmer Karls VII.',
      'forteresse.+1.charlesvii': 'Rückzugsraum Karls VII.',
      'coudray.+1': 'Coudray-Turm, Eb. 1',
      'horloge.+2': 'Uhrturm, Eb. 2',
      'accueil.+2.terrasse': 'Terrasse des Fort Saint-Georges',
      'coudray.+2': 'Coudray-Turm, Eb. 2',
      'horloge.+3': 'Uhrturm, Eb. 3',
      'horloge.+4': 'Uhrturm, Eb. 4',
      'horloge.+5': 'Uhrturm, Rundweg',
    },
    'france.gordes.senanque': {
      'chauffoir.0': 'Wärmestube',
      'chapitre.0': 'Kapitelsaal',
      'abbatiale.0': 'Abteikirche',
      'cloitre.0': 'Kreuzgang',
      'boutique.0': 'Klosterladen',
      'entree.0': 'Empfang/Ticketverkauf',
      'refectoire.0': 'Kreuzgang',
      'accueil.1': 'Empfang/Ticketverkauf',
      'maquette.1': 'Saal der Modelle',
      'dortoir.1': 'Dormitorium',
      'billetterie.1': 'Empfang/Ticketverkauf',
    },
    'france.paris.pcv': {
      conciergerie: 'Die Conciergerie',
      louvretoday: 'Das Musée du Louvre',
      opera: 'Die Opéra Garnier',
      trocadero: 'Der Trocadéro',
      invalides: 'Der Invalidendom',
      placevendome: 'Der Place Vendôme',
      avenueopera: 'Die Avenue de l‘Opéra',
      institutdefrance: 'Das Institut de France',
      pantheon: 'Der Panthéon',
      luxembourg: 'Der Jardin du Luxembourg',
      saintsulpice: 'Die Kirche Saint-Sulpice',
      saintgermaindespres: 'Saint-Germain-des-Prés',
      beauxarts: 'Die Kunsthochschule École Nationale Supérieure des Beaux-arts',
      bouquiniste: 'Die Bouquinistes',
      orsay: "Das Musée d'Orsay",
      concorde: 'Der Place de la Concorde',
      champselysees1: 'Die Champs-Élysées',
      quartierelysee: 'Das Élysée-Viertel',
      champselysees2: 'Die Champs-Élysées',
      lido: 'Der Lido de Paris',
      arcdetriomphe: 'Der Arc de Triomphe',
      immeublehaussmanien: 'Ein Haussmann-Gebäude',
      palaistokyo: 'Der Palais de Tokyo',
      alma: 'Der Place de l‘Alma',
      toureiffel: 'Blick vom Eiffelturm',
      museebranly: 'Das Musée du Quai Branly – Jacques-Chirac',
      tuileries: 'Der Tuilerien-Garten',
      kiosquepcv: 'Unsere Angebote',
      hdv: 'Das Rathaus',
      notredame: 'Notre-Dame de Paris',
      assembleenationale: 'Die Assemblée Nationale',
      comediefrancaise: 'Die Comédie-Française',
      sorbonne: 'Die Universität Sorbonne',
      kiosquepcvtuileries: 'Unsere Angebote',
      stopbateaux: 'Reisestopp und Eiffelturm',
      louvremedieval: 'Die Louvre-Festung',
      louvre: 'Der Louvre nach Ludwig XIV.',
      pcvend: 'PCV end',
      pcvstart: 'PCV start',
    },
    'france.arcetsenans.saline': {
      'accueil.0': 'Kartenverkauf',
      'exterieuraccueil.0': 'Hof ',
      'hallmaisondirecteur.0': 'Flur',
      'museeselsalle1.0': 'Salzmuseum - Raum 1',
      'museeselsalle2.0': 'Salzmuseum - Raum 2',
      'museeselsalle3.0': 'Salzmuseum - Raum 3',
      'museeselsalle4.0': 'Flur',
      'museeselsalle5.0': 'Salzmuseum - Raum 5',
      'museeselsalle6.0': 'Salzmuseum - Raum 6',
      'berneouest.0': 'Westliches Siedehaus',
      'tonnellerieentree.0': 'Auditorium',
      'tonnelleriemusee.0': 'Ledoux Museum - Das ausgeführte Werk',
      'tonnelleriemusee.galerieledoux.0': 'Ledoux Museum - Das ausgeführte Werk',
      'tonnelleriemusee.filmguimard.0': 'Ledoux Museum - Das ausgeführte Werk',
      'tonnelleriemusee.filmbesancon.0': 'Ledoux Museum - Das ausgeführte Werk',
      'tonnelleriemusee.filmsaline.0': 'Ledoux Museum - Das ausgeführte Werk',
      'tonnelleriemusee.filmthelusson.0': 'Ledoux Museum - Das ausgeführte Werk',
      'tonnelleriemusee.galerieprojets.0': 'Ledoux Museum - Die Projekte',
      'bernierest.0': 'Ostlicher Wohnblock der Salzwerker',
      'bernierest.cuisine.0': 'Ostlicher Wohnblock der Salzwerker',
      'bernierest.jardins.0': 'Die Gärten',
      'exterieurmuseesel.0': 'Hof ',
      'exterieurnord.0': 'Hof ',
      'exterieurouest.0': 'Hof ',
      'exterieursudouest.0': 'Hof ',
      'exterieursudest.0': 'Hof ',
      'exterieurest.0': 'Hof ',
      'paliermaisondirecteur.1': 'Treppenabsatz im 1. Stock',
      'tonnellerieetage.1': 'Ledoux Museum - Die Wachtore von Paris',
      'toilettesberneest.0': 'Toiletten Ostlicher Wohnblock',
      'boutique.0': 'Geschäft',
      'alarm.0': 'Alarm',
    },
    'deutschland.meissen.albrechtsburg': {
      'basementhall.-1': 'Kellerhalle',
      'sludgecellarvestibule.-1': 'Vorraum zum Schlämmereikeller',
      'staircase.-1': 'Treppenraum',
      'reception.0': 'Foyer - Shop - Café',
      'cloakroom.0': 'Garderobe (Schließfächer)',
      'specialexhibitionarea.0': 'Sonderausstellungsbereich',
      'littlespiralstaircase.0': 'Kleiner Wendelstein',
      'largehall.1': 'Großer Saal',
      'largecourthall.1': 'Große Hofstube',
      'smalldiningroom.1': 'Kleine Tafelstube',
      'firstelectorsroom.1': 'Erstes Kurfürstenzimmer',
      'secondelectorsroom.1': 'Zweites Kurfürstenzimmer',
      'chapel.1': 'Kapelle',
      'smallroom.1': 'Kleine Saalstube',
      'littlespiralstaircase.1': 'Kleiner Wendelstein',
      'largespiralstaircase.1': 'Großer Wendelstein',
      'largestaircaseantechamber.2': 'Vorsaal am Großen Wendelstein',
      'bottgerroom.2': 'Böttgerzimmer',
      'smallappellationroom.2': 'Kleine Appellationsstube',
      'largeappellationroom.2': 'Große Appellationsstube',
      'electoraugustsroom.2': 'Kurfürst-August-Zimmer',
      'heraldichall.2': 'Wappensaal',
      'spiralstaircaseroom.2': 'Stube am Wendelstein',
      'largeappellationroomchamber.2': 'Kammer neben der Großen Appellationsstube',
      'oldduchesschamber.2': 'Der alten Herzogin Gemach',
      'spiralstaircasechamber.2': 'Kammer am Wendelstein',
      'chapel.2': 'Kapellenturmstübchen',
      'ladieschamber.2': 'Frauengemach',
      'smallspiralstaircaseantechamber.2': 'Vorsaal am Kleinen Wendelstein',
      'littlespiralstaircase.2': 'Kleiner Wendelstein',
      'largespiralstaircase.2': 'Großer Wendelstein',
      'ladiesroom1.3': 'Frauenzimmer 1',
      'chamberbytheladiesrooms.3': 'Kammer neben dem Frauenzimmer',
      'ladiesroom2.3': 'Frauenzimmer 2',
      'ladiesroom3.3': 'Frauenzimmer 3',
      'ladiesroom4.3': 'Frauenzimmer 4',
      'chamberinfrontofladiesrooms.3': 'Kammer gegenüber dem Frauenzimmer',
      'menschamber.3': 'Herrengemach',
      'chapel.3': 'Nachtigallenstübchen',
      'largestaircaseantechamber.3': 'Vorsaal am Großen Wendelstein',
      'spiralstaircaseroom.3': 'Stube am Wendelstein',
      'spiralstaircasechamber.3': 'Kammer am Wendelstein',
      'councilchamber.3': 'Ratsstube',
      'chambertocouncilroom.3': 'Kammer zur Ratsstube',
      'littlespiralstaircase.3': 'Kleiner Wendelstein',
      'largespiralstaircase.3': 'Großer Wendelstein',
      'toilets.-1': 'Toiletten',
    },
    'deutschland.moritzburg.schlossmoritzburg': {
      'entrancehall.0': 'Eingangshalle',
      'anteroomtofeatherroom.0': 'Vorraum Federzimmer',
      'exhibitionroom.0': 'Austellungsräume',
      'featherroom.0': 'Federzimmer',
      'entrancehall.0.timegate1945': 'Eingangshalle',
      'entrancehall.0.timegateguestbook': 'Eingangshalle',
      'toilets.0': 'Toiletten',
      'shop.0': 'Geschäft',
      'restaurant.0': 'Restaurant',
      'reception.0': 'Rezeption',
      'stonehall.1': 'Steinsaal',
      'stonehall.1.timegateselfie': 'Steinsaal',
      'monstroushall.1': 'Monströsensaal',
      'palacechapel.1': 'Schlosskapelle',
      'dininghall.1': 'Festsaal',
      'billiardhall.1': 'Billardsaal',
      'furnitureroom.1': 'Quartier für königliche Familienmitglieder, Raum 2',
      'augustroom1.1': 'Quartier König Augusts des Starken, Raum 1',
      'augustroom2.1': 'Quartier König Augusts des Starken, Raum 2',
      'ladiesportraitsroom.1': 'Quartier der Kurprinzessin Maria Josepha, Raum 3',
      'guestroom2.1': 'Quartier der Kurprinzessin Maria Josepha, Raum 1',
      'electorroom1.1': 'Quartier des Kurprinzen Friedrich August, Raum 1',
      'electorroom2.1': 'Quartier des Kurprinzen Friedrich August, Raum 2',
      'bruhlroom.1': 'Quartier des Kurprinzen Friedrich August, Raum 3',
    },
    'germany.colditz.schloss-colditz': {
      'guardhouse.0.welcomearea': 'Startseite',
      'chapel.0': 'Kirchenhaus',
      'electorshouse.0.displaydepot': 'Fürstenhaus',
      'electorshouse.0.silverchamber': 'Silberkammer',
      'courtyard.0': 'Hinterer Schlosshof',
      'guardhouse.1.chamber': 'Die Wache',
      'cellar.1.banquetroom': 'Tafelstube',
      'cellar.1.anteroom': 'Vorraum',
      'cellar.1.huntingroom': 'Jagdstube',
      'cellar.1.storeroom': 'Untere Kirchstube',
      'chapel.1.gallery': 'Untere Kirchstube',
      'chapel.2.bath': 'Fluchtmuseum I',
      'chapel.3.womanapartments': 'Fluchtmuseum II',
      'chapel.4.gliderloft': 'Fluchtmuseum III',
    },
  },
}
